<template>
  <DialogTemplateToolkit
    :dialog="dialog"
    :first_btn="firstBtn"
    :second_btn="second_btn"
    :title="title"
    :without_second_btn="!second_btn"
    @action="secondBtnAct"
    @apply="submitDialog"
    @close="closeDialog">
    <template #second_btn>
      <slot name="accepting_second_btn"/>
    </template>
    <template #activator-btn>
      <slot name="activator">
        <sButton
          data-qa="accepting-dialog-send"
          :disabled="disabled_open"
          :loading="loading"
          @click="openDialog">
          {{ btn_text || $t('Catalog.Send') }}
        </sButton>
      </slot>
    </template>
    <template #card-text>
      <div>
        <div
          v-if="!without_accept">
          <div
            v-if="acceptors && acceptors.length > 0 && !load_acceptors"
            class="pa-0 main__light_green">
            <span>{{ $t('Catalog.MustAapprove') }}</span>
            <div
              v-for=" acceptor in acceptors"
              :key="acceptor.userId || acceptor.contactId"
              class="px-0">
              <PersonTooltip
                :avatar=" acceptor.avatar || ''"
                :department="acceptor ? acceptor.department : {}"
                :name=" acceptor.fullName || (acceptor.user && acceptor.user.id ) || acceptor.fio || acceptor.name"
                :status="acceptor.status"
                with_photo/>
            </div>
          </div>
          <v-skeleton-loader
            v-else-if="load_acceptors"
            :boilerplate="false"
            class="flex flex-wrap"
            :tile="false"
            type="avatar, sentences"
            width="200px"/>
        </div>
        <slot name="additional_text"/>
        <span>{{ card_text || $t('Catalog.WillNotify') }}</span>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>

<script>
import PersonTooltip from 'components/common/blocks/PersonTooltip.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

export default {
  name: 'acceptingDialog',
  data() {
    return {
      dialog: false
    }
  },
  props: {
    without_accept: Boolean,
    acceptors: Array,
    title: String,
    disabled_open: Boolean,
    sendAction: Function,
    second_btn: String,
    btn_text: String,
    card_text: String,
    loading: Boolean,
    load_acceptors: Boolean,
    close: Function,
    submit: Function,
    secondBtnAction: Function,
    firstBtn: {
      type: String,
      default: 'Common.ThankYou'
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    closeDialog(cond) {
      if ( this.close && !cond) {
        return this.close()
      }
      this.dialog = false
    },

    secondBtnAct() {
      if ( this.secondBtnAction) {
        return this.secondBtnAction()
      }
    },
    openDialog() {
      if (this.sendAction) {
        return this.sendAction()
      }
      this.dialog = true
    },
    submitDialog() {
      if ( this.submit) {
        return this.submit()
      }
      this.dialog = false
    }
  },
  components: {
    PersonTooltip,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss" scoped>
.exit-btn {
  position: absolute;
  top: 20px;
  right: 20px;
}
.created-purch-dialog {
  text-align: start;
  color: var(--text-color);

}
.footer {
  border-top: 2px solid var(--black-color);
  height: 60px;
}
.v-card__title {
  font-weight: 600;
  letter-spacing: 0.01em;
  span {
    word-break: break-word;
  }
}
.avatars.block {
  position: relative;
  min-width: 20px;
  width: auto;
  height: 30px;
  display: inline-block;
  .avatars {
    position: relative;
    top: 0px;
    // border: 1px solid var(--white-color);
    border-radius: 15px;
  }
}
</style>
